import { AddressType } from '../../constants/address-type.js';
import { isBlankAddressPairForm } from '../address/is-blank-address-pair-form.js';
import { suggestCustomerAddressName } from './rules.js';
/** True when nothing but the auto-suggested nicknames is filled in, so New Customer creates no address. */
export function isBlankCustomerAddressPairForm(values, customerName) {
    const name = customerName.trim();
    return isBlankAddressPairForm(values, {
        sameAsField: 'billingSameAsShipping',
        secondaryField: 'billing',
        shippingNickname: suggestCustomerAddressName(name, AddressType.SHIPPING),
        secondaryNickname: suggestCustomerAddressName(name, AddressType.BILLING),
    });
}
//# sourceMappingURL=is-blank-customer-address-pair-form.js.map